import React, { useState, useRef, useMemo, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { MerchantEditAddForm } from "./MerchantEditAddForm";
import { useSnackbar } from "notistack";

import { Link } from "react-router-dom";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { fetchSingleBcMerchant, fetchSingleWixMerchant, fetchSingleWpMerchant, updateBcMerchant, updateWixMerchant, updateWpMerchant } from "../../../actions/merchants/merchants";

export function MerchantEdit({
  history,
  match: {
    params: { id,type },
  },
}) {

  const { enqueueSnackbar } = useSnackbar();

  const { wixmerchantForEdit, wpmerchantForEdit, bcmerchantForEdit } = useSelector(
    (state) => ({
      wixmerchantForEdit: id ? state.merchants.wixmerchantForEdit?.docs : undefined,
      wpmerchantForEdit: id ? state.merchants.wpmerchantForEdit?.data : undefined,
      bcmerchantForEdit: id ? state.merchants.bcmerchantForEdit?.docs : undefined,
    }),
    shallowEqual
  );

  var initMerchantsInfo = {
    instanceId: typeof(wixmerchantForEdit?.instanceId) === 'undefined' ? '' : wixmerchantForEdit?.instanceId,
    state: typeof(wixmerchantForEdit?.state) === 'undefined' ? '' : wixmerchantForEdit?.state,
    extra_email: typeof(wixmerchantForEdit?.extra_email) === 'undefined' ? '' : wixmerchantForEdit?.extra_email
  }

  if (type === 'wp') {
    initMerchantsInfo = {
      id: typeof(wpmerchantForEdit?.id) === 'undefined' ? '' : wpmerchantForEdit?.id,
      user_id: typeof(wpmerchantForEdit?.user_id) === 'undefined' ? '' : wpmerchantForEdit?.user_id,
      store_url: typeof(wpmerchantForEdit?.store_url) === 'undefined' ? '' : wpmerchantForEdit?.store_url,
      user_email: typeof(wpmerchantForEdit?.user_email) === 'undefined' ? '' : wpmerchantForEdit?.user_email,
      user_email2: typeof(wpmerchantForEdit?.user_email2) === 'undefined' ? '' : wpmerchantForEdit?.user_email2,
    }
  }

  if (type === 'bc') {
    initMerchantsInfo = {
      id: typeof(bcmerchantForEdit?.id) === 'undefined' ? '' : bcmerchantForEdit?.id,
      user_id: typeof(bcmerchantForEdit?.user_id) === 'undefined' ? '' : bcmerchantForEdit?.user_id,
      store_url: typeof(bcmerchantForEdit?.shop) === 'undefined' ? '' : bcmerchantForEdit?.shop,
      user_email: typeof(bcmerchantForEdit?.user_email) === 'undefined' ? '' : bcmerchantForEdit?.user_email,
      extra_email: typeof(bcmerchantForEdit?.extra_email) === 'undefined' ? '' : bcmerchantForEdit?.extra_email,
    }
  }

  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useMemo(async () => {
    if (id === undefined) {
      return;
    }

    if (type === 'wix') {
      
      await dispatch(fetchSingleWixMerchant(id));
    
    } else if (type === 'wp') {
      
      await dispatch(fetchSingleWpMerchant(id));
    
    } else if (type === 'bc') {
      
      await dispatch(fetchSingleBcMerchant(id));
    
    } else {
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch, type]);

  // set Title
  useMemo(() => {
    let _title = id ? "" : "Add Merchant";
    suhbeader.setTitle(_title);
    setTitle(_title);

    if (id) {
      _title = "Edit Merchant";

      if(type === 'wix'){
        _title = "Edit Wix Merchant";
      }

      if(type === 'wp'){
        _title = "Edit Wordpress Merchant";
      }

      if(type === 'bc'){
        _title = "Edit Bigcommerce Merchant";
      }

      setTitle(_title);
      suhbeader.setTitle(_title);
    }
    return {
      _title,
    };
  }, [id, suhbeader]);

  useEffect(() => {
    if (!id) {
      suhbeader.setBreadcrumbs([{ pathname: '/merchants', title: 'Merchant' }, { pathname: '', title: title }]);
    } else {
      suhbeader.setBreadcrumbs([{ pathname: '/merchants', title: 'Merchant' }, { pathname: '', title: title }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tabvalue = params.get('tab');

  const saveMerchantInfo = (values) => {
    setIsLoading(true);

    if (type === 'wix') {
      dispatch(updateWixMerchant(values, id)).then(async (data) => {
        if (data && data.payload) {
          await history.push(`/merchants?tab=${tabvalue}`);

          await enqueueSnackbar(data.payload.message, {
            variant: "success",
            autoHideDuration: 4500,
          });
          setIsLoading(false);
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });
          setIsLoading(false);
        }
      });
    } else if (type === 'wp') {
      dispatch(updateWpMerchant(values, id)).then(async (data) => {
        if (data && data.payload) {
          await history.push(`/merchants?tab=${tabvalue}`);
          await enqueueSnackbar(data.payload.message, {
            variant: "success",
            autoHideDuration: 4500,
          });

          setIsLoading(false);
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });

          setIsLoading(false);
        }
      });
    } else if (type === 'bc') {
      dispatch(updateBcMerchant(values, id)).then(async (data) => {
        if (data && data.payload) {
          await history.push(`/merchants?tab=${tabvalue}`);
          await enqueueSnackbar(data.payload.message, {
            variant: "success",
            autoHideDuration: 4500,
          });

          setIsLoading(false);
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });

          setIsLoading(false);
        }
      });
    }
  };

  const btnRef = useRef();
  const saveMerchantButtonClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToList = () => {
    history.push(`/merchants?tab=${tabvalue}`);
  };

  return (
    <Card>
      {false && <ModalProgressBar />}

      <CardHeader title={title}>
      </CardHeader>
      <CardBody>
        <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
          <li className='nav-item' onClick={() => setTab("basic")}>
            <Link
              to={history.location.pathname}
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle='tab'
              role='tab'
              aria-selected={(tab === "basic").toString()}>
              Basic info
            </Link>
          </li>
        </ul>
        <div className='mt-5'>
          {tab === "basic" && (
            <MerchantEditAddForm
              banner={initMerchantsInfo}
              id={id}
              btnRef={btnRef}
              saveBannerInfo={saveMerchantInfo}
              type = {type}
            />
          )}
          {/* If you add new tab than add more */}
        </div>
      </CardBody>
      <hr />
      <CardHeader title=''>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveMerchantButtonClick}>
            {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
    </Card>
  );
}
